import { Layout } from "$components";
import { Loader } from "$components/Layout/Loader";
import useDockyardDetailsLogic from "./hooks/useDockyardDetailsLogic";
import DockyardHeader from "./sections/DockyardHeader";
import DockyardGeneralInfo from "./sections/DockyardGeneralInfo";
import DockyardContactInfo from "./sections/DockyardContactInfo";
import DockyardAttachments from "./sections/DockyardAttachments";
import DockyardModals from "./sections/DockyardModals";
import Orders from "./Orders";
import EDBs from "./EDBs";
import { useStyles } from "./styles";

export { type IDockyardProps } from "./types";

function DockyardDetail() {
  const classes = useStyles();
  const logic = useDockyardDetailsLogic();

  if (!logic.idChantier) {
    return null;
  }

  return (
    <Layout
      renderHead={() => (
        <DockyardHeader
          dockyard={logic.dockyard}
          isDockyardDisabled={logic.isDockyardDisabled}
          isDone={logic.isDone}
          canToggleDockyard={logic.canToggleDockyard}
          isContributorUser={logic.isContributorUser}
          isClientUser={logic.isClientUser}
          canEdit={logic.canEdit}
          edbList={logic.edbList}
          hasOrders={logic.hasOrders}
          hasEdbLeft={logic.hasEdbLeft}
          handleSwitchToggle={logic.handleSwitchToggle}
          setModalDeleteOpen={logic.setModalDeleteOpen}
          setModal={logic.setModal}
          isTogglePending={logic.isTogglePending}
        />
      )}
      title={logic.dockyard?.name || ""}
      contentClassName={logic.dockyardFormClasses.LayoutCustom}
    >
      <div className={classes.ContainerInfo} style={{ display: "flex" }}>
        <div
          style={{
            marginRight: 18,
            marginBottom: 18,
            minWidth: "58%",
            maxWidth: "58%",
            display: "flex",
          }}
        >
          <DockyardGeneralInfo
            dockyard={logic.dockyard}
            idChantier={logic.idChantier}
            canEdit={logic.canEdit}
            isFullyDisabled={logic.isFullyDisabled}
            filteredInterveningCompanies={logic.filteredInterveningCompanies}
            handleClickChantier={logic.handleClickChantier}
          />
        </div>

        <DockyardContactInfo
          dockyard={logic.dockyard}
          canEdit={logic.canEdit}
          isFullyDisabled={logic.isFullyDisabled}
          handleClickChantier={logic.handleClickChantier}
        />
      </div>

      {logic.isLoadingEdb && <Loader />}
      {!logic.isLoadingEdb && (
        <EDBs
          dockyard={logic.dockyard}
          edbs={logic.edbList?.data || []}
          handleEdbRedirect={logic.handleEdbRedirect}
          dockyardId={logic.idChantier}
        />
      )}

      <Orders dockyardId={logic.idChantier} setHasOrders={logic.setHasOrders} />

      <DockyardAttachments
        dockyard={logic.dockyard}
        control={logic.control}
        isAdminUser={logic.isAdminUser}
        isFullyDisabled={logic.isFullyDisabled}
        isContributorUser={logic.isContributorUser}
      />

      <DockyardModals
        modalActive={logic.modalActive}
        setModalActive={logic.setModalActive}
        isDockyardDisabled={logic.isDockyardDisabled}
        EnableDockyard={logic.EnableDockyard}
        DisableDockyard={logic.DisableDockyard}
        modal={logic.modal}
        setModal={logic.setModal}
        handleClickTerminate={logic.handleClickTerminate}
        isOpened={logic.isOpened}
        togglePopin={logic.togglePopin}
        dockyardFormClasses={logic.dockyardFormClasses}
        formDockyard={logic.formDockyard}
        handleSubmit={logic.handleSubmit}
        error={logic.error}
        submitting={logic.submitting}
        modalDeleteOpen={logic.modalDeleteOpen}
        setModalDeleteOpen={logic.setModalDeleteOpen}
        handleDeleteDockyard={logic.handleDeleteDockyard}
        errorMessage={logic.errorMessage}
        handleCloseError={logic.handleCloseError}
      />
    </Layout>
  );
}

export default DockyardDetail;
